import { ConfigProvider } from "antd";
import dayjs from "dayjs";
import { RouterProvider } from "react-router-dom";
import "./i18n";
import "./index.css";
import router from "./routes";

import useConfig from "features/config/hooks/useConfig";
import { onMessage } from "firebase/messaging";
// import useFirebaseNoti from "lib/useFirebaseNoti";
import { useEffect } from "react";
const App = () => {
  const { theme } = useConfig();
  const defaultLng = window.localStorage.getItem("lang") || "en";
  // const { fetchToken, messaging, getCountNotificationFn } = useFirebaseNoti()
  dayjs.locale(defaultLng);

  // useEffect(() => {
  //   fetchToken()
  // }, [])


  // useEffect(() => {
  //   if (!messaging) {
  //     console.warn("Cannot attach onMessage listener: messaging is null.");
  //     return;
  //   }

  //   const unsubscribe = onMessage(messaging, (payload) => {
  //     if (payload) {
  //       getCountNotificationFn();
  //     }
  //     // console.log(payload);
  //   });

  //   return () => {
  //     // Clean up listener if needed (depends on Firebase internals)
  //     unsubscribe?.();
  //   };
  // }, [messaging, getCountNotificationFn]);


  // useEffect(() => {
  //   window.scrollTo(0, 0)
  //   // const root = document.querySelector(":root");
  //   // root.style.setProperty("--primary-color", 'red');
  //   // root.style.setProperty("--button-color", `linear-gradient(to right,red , blue)`);
  //   // root.style.setProperty("--button-color-revert", `linear-gradient(to right,red , blue)`);
  // }, [])
  return (
    <ConfigProvider theme={theme}>
      <RouterProvider router={router} />
    </ConfigProvider>
  );
};

export default App;
